import axios from "axios";
import API_URL from "../config";

const client = axios.create({
  baseURL: API_URL,
  // The JWT now lives in an httpOnly cookie set by the server, not in
  // localStorage — so every request needs to actually send cookies
  // cross-origin. There is no token for JS to read or attach anymore,
  // which is the point: an XSS bug elsewhere in the app can no longer
  // steal the session by reading localStorage.
  withCredentials: true,
});

export default client;
